import { Progress } from '@base-ui/react/progress';

import { cn } from '../lib/cn';

export function ProgressBar({
  value,
  label = 'Progress',
  className,
}: {
  value: number | null;
  label?: string;
  className?: string;
}) {
  const clamped =
    value === null ? null : Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 0;
  return (
    <Progress.Root value={clamped} aria-label={label}>
      <Progress.Track className={cn('bg-line h-1.5 w-full overflow-hidden', className)}>
        <Progress.Indicator className="ui-progress-indicator bg-accent h-full transition-[width] data-[indeterminate]:w-1/3 data-[indeterminate]:animate-[progress-slide_1.5s_ease-in-out_infinite]" />
      </Progress.Track>
    </Progress.Root>
  );
}
